
export const calculateSIPReturns = (sipAmount, tenureInYears, annualReturnRate) => {
    const months = tenureInYears * 12;
    const monthlyRate = annualReturnRate / 12 / 100;
    const investedAmount = sipAmount * months;
    const futureValue = sipAmount * ((Math.pow(1 + monthlyRate, months) - 1) * (1 + monthlyRate) / monthlyRate);
    const totalInvestment = sipAmount * months;
    const profit = futureValue - totalInvestment;
    const profitPercentage = (profit / investedAmount) * 100;

    return {
        sipAmount: Math.round(sipAmount),
        tenureInYears: tenureInYears,
        annualReturnRate: annualReturnRate,
        totalValue: Math.round(futureValue),
        profit: Math.round(profit),
        investedAmount: Math.round(investedAmount),
        profitPercentage: Math.round(profitPercentage)
    };
};

export const generateReport = (sipAmount, tenureInYears, expectedReturnRate) => {
    const sipReport = calculateSIPReturns(sipAmount, tenureInYears, expectedReturnRate);
    let reportOfMultipleYears = [];
    for (let year = 0; year <= tenureInYears; year++) {
        reportOfMultipleYears.push(calculateSIPReturns(sipAmount, year, expectedReturnRate))
    }

    return {
        sipReport,
        reportOfMultipleYears
    };
};

